import { Maybe } from '@iss/libs/graphql';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DownloadButtonComponent } from '../download-button';
import { DetailsWrapperComponent } from '../details-wrapper';

@Component({
  selector: 'wo-download-template-skeleton',
  templateUrl: './download-template-skeleton.component.html',
  styleUrls: [ './download-template-skeleton.component.scss' ],
  standalone: true,
  imports: [
    DetailsWrapperComponent,
    DownloadButtonComponent,
  ],
})
export class DownloadTemplateSkeletonComponent {
  @Input({ required: true }) public label!: string;
  @Input({ required: true }) public btnLabel!: string;
  @Input() public loading: Maybe<boolean>;
  @Output() public readonly download = new EventEmitter<void>();
}
